import React from 'react';
import toast from 'react-hot-toast';

import { categoryDataService } from 'services/category.service';
import { notificationDataService } from 'services/notification.service';

import { paths } from 'data/routes';

import { Button } from 'components/Button';
import { DeleteModal } from 'components/DeleteModal';
import { DetailsModal } from 'components/common/DetailsModal/DetailsModal';

import type { StyledActionsProps } from './Actions.styles';
import * as S from './Actions.styles';

type ActionsProps = {
  isViewPath?: boolean;
  isEditPath?: boolean;
  isManagePath?: boolean;
  hasDelete?: boolean;
  id?: string;
  refetch?: () => void;
  tableName?: string;
  rowData?: any;
} & StyledActionsProps;

const defaultProps: Partial<ActionsProps> = {
  isViewPath: false,
  isEditPath: false,
  isManagePath: false,
  toTheRight: false,
  hasDelete: false,
  id: '',
};

export function Actions(props: ActionsProps): React.ReactElement {
  const {
    isViewPath,
    isEditPath,
    isManagePath,
    toTheRight,
    hasDelete,
    tableName,
    rowData,
    id,
    refetch,
  } = {
    ...defaultProps,
    ...props,
  };

  const [isVisible, isVisibleSet] = React.useState(false);

  const sanitizeCode = (v?: string) =>
    typeof v === 'string' ? v.replace(/\s+/g, '').trim() : '';

  const sanitizeLine = (v?: string) =>
    typeof v === 'string' ? v.trim().replace(/\s+/g, ' ') : '';

  const handleDeleteNotification = async (notificationId?: string) => {
    if (!notificationId) return;
    try {
      await notificationDataService.delete(notificationId);
      toast.success('Notification deleted successfully');
      isVisibleSet(false);
      if (refetch) refetch();
    } catch (error) {
      toast.error('Failed to delete notification');
    }
  };

  const handleDeleteCategory = async (categoryId?: string) => {
    if (!categoryId) return;
    try {
      await categoryDataService.delete(categoryId);
      toast.success('Category deleted successfully');
      isVisibleSet(false);
      if (refetch) refetch();
    } catch (error) {
      toast.error('Failed to delete category');
    }
  };

  return (
    <S.Container toTheRight={toTheRight}>
      {isViewPath && (
        <Button onClick={() => isVisibleSet(true)} motive="primaryBlack">
          View
        </Button>
      )}

      {isEditPath && (
        <Button asLink to={`${paths.edit}/${id}`} motive="primaryBlack">
          Edit
        </Button>
      )}

      {isManagePath && (
        <Button
          asLink
          to={`${paths.manage}/${id}?season=${sanitizeCode(
            rowData?.season
          )}&seasonLine=${sanitizeLine(rowData?.marketingLine)}&genderCode=${sanitizeCode(
            rowData?.genderCode
          )}&zone=${sanitizeCode(rowData?.zone)}&type=${sanitizeCode(rowData?.type)}`}
          motive="primaryBlack"
        >
          Manage
        </Button>
      )}
      {hasDelete && (
        <Button
          onClick={() => isVisibleSet(true)}
          iconLeft="FiTrash2"
          $iconSize="1.4"
          type="button"
        />
      )}
      {isVisible && hasDelete && tableName === 'seasons' ? (
        <DeleteModal
          onClose={() => isVisibleSet(false)}
          name="this season"
          onDelete={() => console.log('delete')}
        />
      ) : null}
      {isVisible && hasDelete && tableName === 'zones' ? (
        <DeleteModal
          onClose={() => isVisibleSet(false)}
          name="this zone"
          onDelete={() => console.log('delete zone')}
        />
      ) : null}
      {isVisible && hasDelete && tableName === 'notifications' ? (
        <DeleteModal
          onClose={() => isVisibleSet(false)}
          name="this notification"
          onDelete={() => handleDeleteNotification(id)}
        />
      ) : null}
      {isVisible && hasDelete && tableName === 'notificationsCategories' ? (
        <DeleteModal
          onClose={() => isVisibleSet(false)}
          name="this category"
          onDelete={() => handleDeleteCategory(id)}
        />
      ) : null}
      {isVisible && isViewPath && tableName === 'orders' ? (
        <DetailsModal details={rowData} onClose={() => isVisibleSet(false)} />
      ) : null}
    </S.Container>
  );
}
